module.exports = __webpack_public_path__ + "static/img/classcard-three.dc5f0ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/classcard-three.png
// module id = v2d+
// module chunks = 0